import { TAMANO_PAGINA } from '../api/backoffice.js';

export const ESTADOS_EMPRESA = {
  borrador: { etiqueta: 'Borrador', tono: 'neutral' },
  en_prueba: { etiqueta: 'En prueba', tono: 'info' },
  prueba_terminada: { etiqueta: 'Prueba vencida', tono: 'alerta' },
  activa: { etiqueta: 'Activa', tono: 'exito' },
  vencida: { etiqueta: 'Vencida', tono: 'peligro' },
  suspendida: { etiqueta: 'Suspendida', tono: 'peligro' },
  dada_de_baja: { etiqueta: 'Dada de baja', tono: 'neutral' },
};

export const ESTADOS_SUSCRIPCION = {
  activa: { etiqueta: 'Activa', tono: 'exito' },
  pendiente: { etiqueta: 'Pendiente', tono: 'alerta' },
  cancelada: { etiqueta: 'Cancelada', tono: 'neutral' },
};

export const ESTADOS_TRIAL = {
  activa: { etiqueta: 'Activo', tono: 'info' },
  expirada: { etiqueta: 'Vencido', tono: 'peligro' },
  convertida: { etiqueta: 'Convertido', tono: 'exito' },
};

export const ESTADOS_CONTRATACION = {
  pendiente: { etiqueta: 'Pendiente', tono: 'alerta' },
  aprobada: { etiqueta: 'Aprobada', tono: 'exito' },
  aplicada: { etiqueta: 'Aplicada', tono: 'info' },
  rechazada: { etiqueta: 'Rechazada', tono: 'peligro' },
};

export const ESTADOS_PAGO = {
  pendiente: { etiqueta: 'Pendiente', tono: 'alerta' },
  pagado: { etiqueta: 'Pagado', tono: 'exito' },
  aprobado: { etiqueta: 'Aprobado', tono: 'exito' },
  rechazado: { etiqueta: 'Rechazado', tono: 'peligro' },
  vencido: { etiqueta: 'Vencido', tono: 'peligro' },
  anulado: { etiqueta: 'Anulado', tono: 'neutral' },
  reembolsado: { etiqueta: 'Reembolsado', tono: 'neutral' },
};

export const ESTADOS_BENEFICIO = {
  pendiente: { etiqueta: 'Pendiente', tono: 'alerta' },
  aprobado: { etiqueta: 'Aprobado', tono: 'exito' },
  rechazado: { etiqueta: 'Rechazado', tono: 'peligro' },
  expirado: { etiqueta: 'Expirado', tono: 'neutral' },
  cancelado: { etiqueta: 'Cancelado', tono: 'neutral' },
};

export const CONDICION_EMPRESA = {
  trial: { etiqueta: 'Trial', tono: 'info' },
  pago_normal: { etiqueta: 'Pago normal', tono: 'exito' },
  gratis_permanente: { etiqueta: 'Gratis permanente', tono: 'exito' },
  gratis_hasta_fecha: { etiqueta: 'Gratis temporal', tono: 'info' },
  promocion: { etiqueta: 'Promoción', tono: 'info' },
};

export function crearBadge(configuracion, valor) {
  const meta = configuracion[valor] ?? { etiqueta: valor ?? '—', tono: 'neutral' };
  const badge = document.createElement('pf-badge-estado');
  badge.setAttribute('tono', meta.tono);
  badge.textContent = meta.etiqueta;
  return badge;
}

export function moneda(valor) {
  return new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
    minimumFractionDigits: 2,
  }).format(Number(valor ?? 0));
}

export function fecha(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleDateString('es-PE');
}

export function fechaHora(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleString('es-PE');
}

export function diasRestantes(fechaFin) {
  if (!fechaFin) return '—';
  const dias = Math.ceil((new Date(fechaFin).getTime() - Date.now()) / 86_400_000);
  if (dias < 0) return `${Math.abs(dias)} días vencido`;
  if (dias === 0) return 'Vence hoy';
  return `${dias} días`;
}

export function tarjetaMetrica({ titulo, valor, subtitulo = '', tono = 'neutral' }) {
  return `
    <div class="pf-tarjeta pf-backoffice-card pf-backoffice-card--${tono}">
      <p class="pf-dashboard__tarjeta-etiqueta">${titulo}</p>
      <p class="pf-dashboard__tarjeta-valor">${valor}</p>
      ${subtitulo ? `<p class="pf-dashboard__tarjeta-subtitulo">${subtitulo}</p>` : ''}
    </div>
  `;
}

export function estadoCarga(texto = 'Cargando...') {
  return `<div class="pf-tarjeta pf-backoffice-empty">${texto}</div>`;
}

export function estadoError(texto) {
  return `<div class="pf-campo__error pf-backoffice-error">${texto}</div>`;
}

export function crearPaginacion({ total = 0, pagina = 1, alCambiar }) {
  const totalPaginas = Math.max(1, Math.ceil(total / TAMANO_PAGINA));
  const contenedor = document.createElement('div');
  contenedor.className = 'pf-backoffice-pagination';
  contenedor.innerHTML = `
    <span class="pf-texto-suave">Página ${pagina} de ${totalPaginas} · ${total} registros</span>
    <div class="pf-fila">
      <button type="button" class="pf-boton pf-boton--secundario pf-boton--chico" data-pagina="${pagina - 1}" ${pagina <= 1 ? 'disabled' : ''}>Anterior</button>
      <button type="button" class="pf-boton pf-boton--secundario pf-boton--chico" data-pagina="${pagina + 1}" ${pagina >= totalPaginas ? 'disabled' : ''}>Siguiente</button>
    </div>
  `;

  contenedor.querySelectorAll('button[data-pagina]').forEach((boton) => {
    boton.addEventListener('click', () => alCambiar(Number(boton.dataset.pagina)));
  });

  return contenedor;
}

export function obtenerSuscripcionActual(empresa) {
  const lista = Array.isArray(empresa?.suscripcion) ? empresa.suscripcion : [];
  return lista.find((s) => s.estado === 'activa') ?? lista[0] ?? null;
}

export function motivoRapido(mensaje) {
  return window.prompt(mensaje)?.trim() ?? '';
}

export function normalizarCaracteristicas(texto) {
  const limpio = texto.trim();
  if (!limpio) return {};

  try {
    return JSON.parse(limpio);
  } catch {
    return {
      notas: limpio
        .split('\n')
        .map((linea) => linea.trim())
        .filter(Boolean),
    };
  }
}
